// Test script to verify Firebase connection
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs } from "firebase/firestore";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Function to test Firebase connection
async function testFirebaseConnection() {
  console.log("Testing Firebase connection...");
  console.log("Firebase config:", {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? "Set" : "Not set",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? "Set" : "Not set",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ? "Set" : "Not set",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ? "Set" : "Not set",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ? "Set" : "Not set",
    appId: process.env.REACT_APP_FIREBASE_APP_ID ? "Set" : "Not set"
  });
  
  try {
    // Try to get documents from the users collection
    const querySnapshot = await getDocs(collection(db, "users"));
    console.log("Firebase connection successful!");
    console.log(`Retrieved ${querySnapshot.size} documents from users collection`);
    return true;
  } catch (error) {
    console.error("Firebase connection failed:", error);
    return false;
  }
}

// Execute the test
testFirebaseConnection()
  .then(success => {
    console.log("Test completed. Success:", success);
  })
  .catch(error => {
    console.error("Test failed with error:", error);
  });

export { testFirebaseConnection };